import React from 'react'

const Partner = () => {
    return (
        <div className="partner-area pt-100 pb-70 bg-f1f8fb">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-2 col-6 col-sm-4 col-md-4">
                        <div className="single-partner-item wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                            <img src="assets/img/partner/img1.png" alt="image"/>
                        </div>
                    </div>

                    <div className="col-lg-2 col-6 col-sm-4 col-md-4">
                        <div className="single-partner-item wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
                            <img src="assets/img/partner/img2.png" alt="image"/>
                        </div>
                    </div>

                    <div className="col-lg-2 col-6 col-sm-4 col-md-4">
                        <div className="single-partner-item wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                            <img src="assets/img/partner/img3.png" alt="image"/>
                        </div>
                    </div>

                    <div className="col-lg-2 col-6 col-sm-4 col-md-4">
                        <div className="single-partner-item wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
                            <img src="assets/img/partner/img4.png" alt="image"/>
                        </div>
                    </div>

                    <div className="col-lg-2 col-6 col-sm-4 col-md-4">
                        <div className="single-partner-item wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1500ms">
                            <img src="assets/img/partner/img5.png" alt="image"/>
                        </div>
                    </div>

                    <div className="col-lg-2 col-6 col-sm-4 col-md-4">
                        <div className="single-partner-item wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                            <img src="assets/img/partner/img6.png" alt="image"/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="divider"></div>
        </div>
    )
}

export default Partner
